{
    "apiKey": "AIzaSyBnB9ORwqB37HvHouRzEZ5d1Jrb21oT3So",
    "authDomain": "vas-mng-svi-cu00002742p1-l12.firebaseapp.com",
    "projectId": "vas-mng-svi-cu00002742p1-l12",
    "storageBucket": "vas-mng-svi-cu00002742p1-l12.firebasestorage.app",
    "messagingSenderId": "820500319892",
    "appId": "1:820500319892:web:443ef0b6593c7f02992e81"
}